import { axiosFactory } from './axios.factory';

export default axiosFactory();
